import { Checkbox as VuiCheckbox } from '@village/ui';
import { device } from 'citymd/constants/device';
import { RadioValuesContainer, RadioInput } from 'components/fields/radio-form/styles';
import { rem } from 'polished';
import styled from 'styled-components';

export const Fields = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${rem(24)};
`;

export const ResponsiveFields = styled.div<{ $template: string }>`
    display: grid;
    gap: ${rem(24)};
    grid-template-columns: ${({ $template }) => $template};

    @media ${device.maxMobile} {
        grid-template-columns: 1fr;
    }
`;

export const Checkbox = styled(VuiCheckbox)`
    .MuiButtonBase-root {
        color: ${({ theme }) => theme.vui.component.input.default.default.borderColor};
    }

    & .Mui-checked {
        color: ${({ theme }) => theme.vui.colors.icon.default};
    }
`;

export const FieldsGroup = styled.section`
    display: flex;
    flex-direction: column;
    row-gap: ${rem(24)};

    label {
        font-family: CeraProBold, arial, sans-serif;
        padding-left: 0;
    }

    input {
        caret-color: ${({ theme }) => theme.vui.colors.text.default};
    }

    @media (hover: hover) {
        .MuiOutlinedInput-root:hover:not(.Mui-focused),
        .MuiOutlinedInput-root.Mui-focused:hover {
            color: ${({ theme }) => theme.vui.colors.text.default};
        }
    }

    input[type='email'],
    input[type='text'] {
        border: none;
    }

    .MuiInputBase-root.MuiOutlinedInput-root > .MuiInputBase-input {
        max-width: 100%;
        text-indent: 0;
        height: ${rem(48)};
        color: ${({ theme }) => theme.vui.colors.text.default};
    }

    ${RadioInput} {
        font-family: CeraProRegular; /* stylelint-disable-line font-family-no-missing-generic-family-keyword */
        padding: 0 ${rem(20)};
        color: ${({ theme }) => theme.vui.colors.text.default};

        & .Mui-checked {
            color: ${({ theme }) => theme.vui.colors.icon.default};
        }
    }
    ${RadioValuesContainer} {
        border-color: ${({ theme }) => theme.vui.colors.border.tertiary.default};
        border-radius: 0;
    }

    .MuiRadio-root {
        color: ${({ theme }) => theme.vui.colors.border.default.default};

        .MuiSvgIcon-root {
            height: ${rem(20)};
            width: ${rem(20)};
        }
    }
`;

export const FieldsGroupsContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${rem(48)};
`;

export const FormContainer = styled.div`
    display: flex;
    flex-direction: column;
    row-gap: ${rem(40)};
`;

export const EmailFields = styled.div`
    display: grid;
    row-gap: ${rem(16)};
    font-family: CeraProMedium, arial, sans-serif;
`;

export const NoEmailContainer = styled.div`
    label {
        font-family: CeraProRegular, arial, sans-serif;
    }
`;
